import { resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withCtx as _withCtx, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-b2699456"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "img-touch",
  style: {}
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_image = _resolveComponent("van-image");
  const _component_van_image_preview = _resolveComponent("van-image-preview");
  const _component_van_action_sheet = _resolveComponent("van-action-sheet");
  const _directive_touch = _resolveDirective("touch");
  return _openBlock(), _createElementBlock("div", {
    class: "c-image-preview",
    style: _normalizeStyle($options.styles)
  }, [_createVNode(_component_van_image_preview, {
    show: $data.visible,
    "onUpdate:show": _cache[0] || (_cache[0] = $event => $data.visible = $event),
    images: $data.paramOptions.images,
    startPosition: $data.paramOptions.startPosition,
    onChange: $options.onChange,
    onOnClose: $options.handleClose
  }, {
    image: _withCtx(({
      src
    }) => [_createVNode(_component_van_image, {
      src: src,
      style: {
        "width": "100%"
      }
    }, null, 8, ["src"]), _withDirectives(_createElementVNode("div", _hoisted_1, null, 512), [[_directive_touch, $options.pressFunctions[$options.getIndex(src)], "press"], [_directive_touch, $options.handleClose, "swipedown"]])]),
    _: 1
  }, 8, ["show", "images", "startPosition", "onChange", "onOnClose"]), _createVNode(_component_van_action_sheet, {
    show: $data.showAction,
    "onUpdate:show": _cache[1] || (_cache[1] = $event => $data.showAction = $event),
    actions: $data.actions,
    "cancel-text": this.$t('cfmoto.cancel'),
    "close-on-click-action": "",
    onCancel: $options.onCancel,
    onSelect: $options.onSelect
  }, null, 8, ["show", "actions", "cancel-text", "onCancel", "onSelect"])], 4);
}